import SalaryAllowanceConstants from "../constants/salary-allowance-constants";

const initState = {
	airticketAllowance: {
		filters: {
			page: 1,
			employee_info: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	employeeInsurance: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	housingAllowance: {
		filters: {
			page: 1,
			employee_info: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	insuranceLedger: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	insuranceManagement: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	salaryHistory: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	salaryLedger: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	salaryManagement: {
		filters: {
			page: 1,
			job_status: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	}
}


export default function salaryAllowance (state = initState, action) {
	switch (action.type) {
		// air ticket allowance
		case SalaryAllowanceConstants.ActionTypes.CHANGEAIRTICKETALLOWANCE:
			return {
				...state,
				airticketAllowance: {
					...state.airticketAllowance,
					filters: {
						...state.airticketAllowance.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.airticketAllowance.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTAIRTICKETALLOWANCE:
			return {
				...state,
				airticketAllowance: {
					...state.airticketAllowance,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case SalaryAllowanceConstants.ActionTypes.UPDATEAIRTICKETALLOWANCE:
			return {
				...state,
				airticketAllowance: {
					...state.airticketAllowance,
					data: {
						...state.airticketAllowance.data,
						Data: [
							...state.airticketAllowance.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.airticketAllowance.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// employee insurance
		case SalaryAllowanceConstants.ActionTypes.CHANGEEMPLOYEEINSURANCE:
			return {
				...state,
				employeeInsurance: {
					...state.employeeInsurance,
					filters: {
						...state.employeeInsurance.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.employeeInsurance.loadCounter + action.payload.counter
				}
			}
		case SalaryAllowanceConstants.ActionTypes.SELECTEMPLOYEEINSURANCE:
			return {
				...state,
				employeeInsurance: {
					...state.employeeInsurance,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case SalaryAllowanceConstants.ActionTypes.UPDATEEMPLOYEEINSURANCE:
			return {
				...state,
				employeeInsurance: {
					...state.employeeInsurance,
					data: {
						...state.employeeInsurance.data,
						Data: [
							...state.employeeInsurance.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.employeeInsurance.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}
			
		// housing allowance
		case SalaryAllowanceConstants.ActionTypes.CHANGEHOUSINGALLOWANCE:
			return {
				...state,
				housingAllowance: {
					...state.housingAllowance,
					filters: {
						...state.housingAllowance.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.housingAllowance.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTHOUSINGALLOWANCE:
			return {
				...state,
				housingAllowance: {
					...state.housingAllowance,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case SalaryAllowanceConstants.ActionTypes.UPDATEHOUSINGALLOWANCE:
			return {
				...state,
				housingAllowance: {
					...state.housingAllowance,
					data: {
						...state.housingAllowance.data,
						Data: [
							...state.housingAllowance.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.housingAllowance.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// insurance ledger
		case SalaryAllowanceConstants.ActionTypes.CHANGEINSURANCELEDGER:
			return {
				...state,
				insuranceLedger: {
					...state.insuranceLedger,
					filters: {
						...state.insuranceLedger.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.insuranceLedger.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTINSURANCELEDGER:
			return {
				...state,
				insuranceLedger: {
					...state.insuranceLedger,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// insurance management
		case SalaryAllowanceConstants.ActionTypes.CHANGEINSURANCEMANAGEMENT:
			return {
				...state,
				insuranceManagement: {
					...state.insuranceManagement,
					filters: {
						...state.insuranceManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.insuranceManagement.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTINSURANCEMANAGEMENT:
			return {
				...state,
				insuranceManagement: {
					...state.insuranceManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case SalaryAllowanceConstants.ActionTypes.UPDATEINSURANCEMANAGEMENT:
			return {
				...state,
				insuranceManagement: {
					...state.insuranceManagement,
					data: {
						...state.insuranceManagement.data,
						Data: [
							...state.insuranceManagement.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.insuranceManagement.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// salary history
		case SalaryAllowanceConstants.ActionTypes.CHANGESALARYHISTORY:
			return {
				...state,
				salaryHistory: {
					...state.salaryHistory,
					filters: {
						...state.salaryHistory.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.salaryHistory.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTSALARYHISTORY:
			return {
				...state,
				salaryHistory: {
					...state.salaryHistory,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// salary ledger
		case SalaryAllowanceConstants.ActionTypes.CHANGESALARYLEDGER:
			return {
				...state,
				salaryLedger: {
					...state.salaryLedger,
					filters: {
						...state.salaryLedger.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.salaryLedger.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTSALARYLEDGER:
			return {
				...state,
				salaryLedger: {
					...state.salaryLedger,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// salary management 
		case SalaryAllowanceConstants.ActionTypes.CHANGESALARYMANAGEMENT:
			return {
				...state,
				salaryManagement: {
					...state.salaryManagement,
					filters: {
						...state.salaryManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.salaryManagement.loadCounter + action.payload.counter
				}
			}

		case SalaryAllowanceConstants.ActionTypes.SELECTSALARYMANAGEMENT:
			return {
				...state,
				salaryManagement: {
					...state.salaryManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case SalaryAllowanceConstants.ActionTypes.UPDATESALARYMANAGEMENT:
			return {
				...state,
				salaryManagement: {
					...state.salaryManagement,
					data: {
						...state.salaryManagement.data,
						Data: [
							...state.salaryManagement.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.salaryManagement.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		default :
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/salary-allowance-reducer.js